@if (messageService.messages.length) {
  <div class="messages govuk-inset-text">
    @for (message of messageService.messages; track message) {
      <span> {{message}} </span>
    }
    <!--button class="clear"
  (click)="messageService.clear()">clear</button-->
</div>
}
